"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetTestUsersProgressObjectToJSON = exports.GetTestUsersProgressObjectFromJSONTyped = exports.GetTestUsersProgressObjectFromJSON = void 0;
var _1 = require("./");
function GetTestUsersProgressObjectFromJSON(json) {
    return GetTestUsersProgressObjectFromJSONTyped(json, false);
}
exports.GetTestUsersProgressObjectFromJSON = GetTestUsersProgressObjectFromJSON;
function GetTestUsersProgressObjectFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'amount': json['amount'],
        'stats': (json['stats'].map(_1.GetTestUsersProgressStatSummaryFromJSON)),
    };
}
exports.GetTestUsersProgressObjectFromJSONTyped = GetTestUsersProgressObjectFromJSONTyped;
function GetTestUsersProgressObjectToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'amount': value.amount,
        'stats': (value.stats.map(_1.GetTestUsersProgressStatSummaryToJSON)),
    };
}
exports.GetTestUsersProgressObjectToJSON = GetTestUsersProgressObjectToJSON;
